import { useCallback, useEffect, useState } from "react";
import { Modal, Spin, message } from "antd";
import { serviceApi } from "@/apis";
import Pdf from "../Pdf";
import { DownloadOutlined } from "@ant-design/icons";
import "./index.less";
import { downloadFile } from "@/utils";

const PreviewModal = ({
  previewId,
  isModalOpen,
  setIsModalOpen,
}: {
  previewId: string;
  isModalOpen: boolean;
  setIsModalOpen: any;
}) => {
  const [loading, setLoading] = useState(false);
  const [pdfInfo, setPdfInfo] = useState<RecfindById>();

  const getList = useCallback(async (previewId: string) => {
    try {
      const res = await serviceApi.reconcile_findById({
        id: previewId,
        type: "read",
      });
      setPdfInfo(res);
    } catch (error: any) {
      message.error(error);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (previewId && isModalOpen) {
      getList(previewId);
    }
  }, [previewId, isModalOpen, getList]);

  const downLoadPdf = () => {
    if (!pdfInfo) return;
    downloadFile(`/crm-venus/v1/venus/files/download/${pdfInfo.pdfUrl}.id` , `${pdfInfo.reconciliationDate}对账函.pdf`);
  };

  return (
    <Modal
      style={{ top: 50 }}
      width={900}
      title={<h3 style={{ textAlign: "center" }}>对账函预览</h3>}
      open={isModalOpen}
      onCancel={() => setIsModalOpen(false)}
      footer={null}
      maskClosable={false}
    >
      <Spin spinning={loading}>
        <Pdf pdfInfo={pdfInfo} />
        <div className="download-wrapper">
          <h4>对账资料下载</h4>
          {pdfInfo && (
            <span onClick={downLoadPdf}>
              {pdfInfo.reconciliationDate}对账函.pdf <DownloadOutlined />
            </span>
          )}
        </div>
      </Spin>
    </Modal>
  );
};

export default PreviewModal;
